export enum RolesEnum {
  // Modules
  MyWorkspace = 'My Workspace',
  InboundOperations = 'Inbound Operations',
  OutboundOperations = 'Outbound Operations',
  InventoryOperations = 'Inventory Operations',
  BusinessInsights = 'Business Insights',
  HumanCapital = 'Human Capital',
  SetupFacility = 'Setup Facility',
  TaskManagement = 'Task',
  IncidentManagement = 'Incident Management',
  DistributionManagement='Distribution Management',


  //
  SetupInventory = 'Setup Inventory',
  Administration = 'Administration',
  Report = 'Report',
  SetupSettings = 'Setup Settings',
  SiteSecurity = 'Site Security',
  InboundDiscrepancy ='Inbound Discrepancy',

  //Pages
  MyTasks = 'My Tasks',
  MyInbox = 'My Inbox',
  Announcements = 'Announcements',
  MyReports = 'My Reports',
  MyPerformance = 'My Performance',
  MyProfile = 'My Profile',
  MyPrefereneces ='My Prefereneces',
  InboundNotes = 'Inbound Notes',
  Putaway = 'Putaway',
  AdvanceShippingNoticesASN = 'Advance Shipping Notices (ASN)',
  Receipts = 'Receipts',
  OutboundNotes = 'Outbound Notes',
  DispatchNotesDN = 'Dispatch Notes (DN)',
  PickLists = 'Pick Lists',
  Allocations = 'Allocations',
  StockInsightsList = 'Stock Insights - List',
  Reservations = 'Reservations',
  InventoryHold = 'Inventory Hold',
  Adjustments = 'Adjustments',
  CycleCount = 'Cycle Count',
  StockTransfer = 'Stock Transfer',
  LotManagement = 'Lot Management',
  MoveStock = 'Move Stock',
  BusinessCenter = 'Business Center',
  Reports = 'Reports',
  Performance = 'Performance',
  Teams = 'Teams',
  Shifts = 'Shifts',
  Sites = 'Sites',
  Warehouses = 'Warehouses',
  Areas = 'Areas',
  Locations = 'Locations',
  Zones = 'Zones',
  Docks = 'Docks',
  UserManagement = 'User Management',
  DeviceManagement = 'Device Management',
  DataManagement = 'Data Management',
  Orchestration = 'Orchestration',
  ApprovalWorkflow = 'Approval Workflow',
  LicenseCenter = 'License Center',
  UniversalGateway = 'Universal Gateway',
  AuditTrail = 'Audit Trail',

  IncidentType = 'IncidentType',
  Driver = 'Driver',
  Vehicle = 'Vehicle',
  //
  Training = 'Training',
  Gate = 'Gate',
  SKU = 'SKU',
  SKUGroup = 'SKU Group',
  SKUClass = 'SKU Class',
  SKUPackaging = 'SKU Packaging',
  HazMatClass = 'HazMatClass',
  LotMap = 'LotMap',
  BOQ = 'BOQ',
  Task = 'Task',
  Hold = 'Hold',
  JobTitles = 'Job Titles',

  UserRole = 'User Role',

  Checklist = 'Checklist',
  Productivity = 'Productivity',
  SystemSettings = 'System Settings',
  GateList = 'Gate - List',
  GatePassList ='Gate Pass - List',
  GateSecurityIn = 'Gate Security - In',
  GateSecurityOut = 'Gate Security - Out',

  // Actions
  MyProfileChangePassword = "My Profile - Change Password",
  MyTasksList = 'My Tasks - List',
  MyTasksPickUp = 'My Tasks - PickUp',
  MyTasksOpen = 'My Tasks - Open',
  MyTasksCancelJob='My Tasks - Cancel Job',
  MyTasksDetails = 'My Tasks - Details',
  InboundNotesList = 'Inbound Notes - List',
  InboundNotesDetails = 'Inbound Notes - Details',
  InboundNotesCreate = 'Inbound Notes - Create',
  InboundNotesImport = 'Inbound Notes - Import',
  InboundNotesExport = 'Inbound Notes - Export',
  
  InboundNotesAddInboundNoteLine = 'Inbound Notes - Add Inbound Note Line',
  //InboundNotesExportInboundNoteDetails =' Inbound Notes - Export Inbound Note Details',
  InboundNotesCancel='Inbound Notes - Cancel',
  InboundNotesQuickASN='Inbound Notes - QuickASN',

  InboundNotesExportInboundNoteDetails = 'Inbound Notes - Export Inbound Note Details',
  AdvanceShippingNoticesASNList = 'Advance Shipping Notices (ASN) - List',
  AdvanceShippingNoticesASNDetails = 'Advance Shipping Notices (ASN) -Details',
  AdvanceShippingNoticesASNCreate = 'Advance Shipping Notices (ASN) - Create',
  AdvanceShippingNoticesASNExport = 'Advance Shipping Notices (ASN) - Export',
  AdvanceShippingNoticesASNProcess = 'Advance Shipping Notices (ASN) - Process',
  AdvanceShippingNoticesASNAddASNLine = 'Advance Shipping Notices (ASN) - Add (ASN) Line',
  AdvanceShippingNoticesASNExportASNDetails = 'Advance Shipping Notices (ASN) - Export (ASN) Details',
  AdvanceShippingNoticesUpdateLogistics ='Advance Shipping Notices (ASN) - Update Logistics',
  AdvanceShippingNoticesCancel = 'Advance Shipping Notices (ASN) - Cancel',
  AdvanceShippingNoticesInboundNoteLink = 'Advance Shipping Notices (ASN) - Inbound Note Link',
  AdvanceShippingNoticesReceiptLink = 'Advance Shipping Notices (ASN) - Receipt Link',
  AdvanceShippingNoticesPutawyLink ='Advance Shipping Notices (ASN) - Putawy Link',
  AdvanceShippingNoticesExportASNLines = 'Advance Shipping Notices (ASN) - Export ASN Lines',
 
  ReceiptsList = 'Receipts - List',
  ReceiptsDetails = 'Receipts - Details',
  ReceiptsCreate = 'Receipts - Create',
  ReceiptsExport = 'Receipts - Export',
  ReceiptsAddReceiptLine = 'Receipts - Add Receipt Line',
  ReceiptsExportReceiptDetails = 'Receipts - Export Receipt Details',

  PutawayList ='Putaway - List',
  PutawayASNlines ='Putaway - ASN lines',
  PutawayReversePutaway='Putaway - Reverse Putaway',

  InboundDiscrepancyList =  'Inbound Discrepancy - List',
  InboundDiscrepancyDetails =  'Inbound Discrepancy - Details',
  InboundDiscrepancyApprove =  'Inbound Discrepancy - Approve',
  OutboundNotesList = 'Outbound Notes - List',
  OutboundNotesDetails = 'Outbound Notes - Details',
  OutboundNotesCreate = 'Outbound Notes - Create',
  OutboundNotesImport = 'Outbound Notes - Import',
  OutboundNotesExport = 'Outbound Notes - Export',
  OutboundNotesAddOutboundNoteLine = 'Outbound Notes - Add Outbound Note Line',
  OutboundNotesCancel = 'Outbound Notes - Cancel',
  OutboundNotesQuickDN = 'Outbound Notes - Quick DN',

  DispatchNotesDNList = 'Dispatch Notes (DN) - List',
  DispatchNotesDNDetails = 'Dispatch Notes (DN) -Details',
  DispatchNotesDNAllocate = 'Dispatch Notes (DN) - Allocate',
  DispatchNotesDNDeallocate = 'Dispatch Notes (DN) - Deallocate',
  DispatchNotesDNRelease = 'Dispatch Notes (DN) - Release',
  DispatchNotesDNWave = 'Dispatch Notes (DN) - Wave',
  DispatchNotesDNAddDispatchNotesLine = 'Dispatch Notes (DN) - Add Dispatch Notes Line',
  DispatchNotesDispatchConfirmationReport = 'Dispatch Notes (DN) - Dispatch Confirmation Report',
  DispatchNotesDNExport = 'Dispatch Notes(DN) - Export',

  
DispatchNotesUpdateLogisticsPlan = 'Dispatch Notes (DN) - Update Logistics Plan',
DispatchNotesCancel = 'Dispatch Notes (DN) - Cancel',
DispatchNotesSalesReturn = 'Dispatch Notes (DN) - Sales Return',
DispatchNotesOutboundNoteLink = 'Dispatch Notes (DN) - Outbound Note Link',
DispatchNotesPickDetailsLink = 'Dispatch Notes (DN) - Pick Details Link',
DispatchNotesAllocationDetailsLink ='Dispatch Notes (DN) - Allocation Details Link',
DispatchNotesExportLines ='Dispatch Notes (DN) - Export Lines',

  OutboundDiscrepancyList = 'Outbound Discrepancy - List',
  OutboundDiscrepancyDetails = 'Outbound Discrepancy - Details',
  OutboundDiscrepancyApprove = 'Outbound Discrepancy - Approve',
  PickListsList = 'Pick Lists - List',
  PickListsDetails = 'Pick Lists - Details',
  AllocationsAllocate = 'Allocations - Allocate',
  AllocationsDeallocate = 'Allocations - Deallocate',
  AllocationsCreatePickTask = 'Allocations - Create Pick Task',
  AllocationsWave = 'Allocations - Wave',
  ReservationsMyReservations = 'Reservations - My Reservations',
  ReservationsAllReservations = 'Reservations - All Reservations',
  ReservationsDetails = 'Reservations - Details',
  ReservationsCreateQuickReservation = 'Reservations - Create Quick Reservation',
  ReservationsCreateLongtermReservation = 'Reservations - Create Long-term Reservation',
  ReservationsCreateLotReservation = 'Reservations - Create Lot Reservation',
  InventoryHoldList = 'Hold - List',
  InventoryHoldCreate = 'Hold - Create',
  InventoryHoldUnHold = 'Hold - Unhold',
  AdjustmentsList = 'Adjustments - List',
  AdjustmentsCreate = 'Adjustments -  Create',
  CycleCountList = 'Cycle Count - List',
  CycleCountCreate = 'Cycle Count - Create',
  CycleCountResults ='Cycle Count - Results',
  CycleCountShowMore ='Cycle Count - Show More',
  CycleCountResultsInspect ='Cycle Count - Results Inspect',
  CycleCountResultsApproval ='Cycle Count - Results Approval',
  StockList ='Stock - List',
  StockDetails ='Stock - Details',
  StockTransferList = 'Stock Transfer - List',
  StockTransferDetails = 'Stock Transfer - Details',
  StockTransferCreate = 'Stock Transfer - Create',
  LotManagementList = 'Lot Management - List',
  LotManagementDetails = 'Lot Management - Details',
  LotManagementUpdate = 'Lot Management - Update',
  MoveStockList = 'Move Stock - List',
  MoveStockCreate = 'Move Stock - Create',
  TeamsList = 'Teams - List',
  TeamsDetails = 'Teams - Details',
  TeamsCreate = 'Teams - Create',
  TeamsUpdate = 'Teams - Update',
  TeamsActivate = 'Teams - Activate',
  TeamsDeactivate = 'Teams - Deactivate',
  TeamsAddUsers = 'Teams - Add Users',
  TeamsDeleteUsers = 'Teams - Delete Users',
  TeamsAddAreas = 'Teams - Add Areas',
  TeamsDeleteAreas = 'Teams - Delete Areas',
  TeamsAddActivities = 'Teams - Add Activities',
  TeamsDeleteActivities = 'Teams - Delete Activities',
  TeamsAddOrganizations = 'Teams - Add Organizations',
  TeamsDeleteOrganizations = 'Teams - Delete Organizations',
  SitesList = 'Sites - List',
  SitesDetails = 'Sites - Details',
  SitesCreate = 'Sites - Create',
  SitesUpdate = 'Sites - Update',
  SitesActivate = 'Sites - Activate',
  SitesDeactivate = 'Sites - Deactivate',
  SitesExport = 'Sites - Export',
  WarehousesList = 'Warehouses - List',
  WarehousesDetails = 'Warehouses - Details',
  WarehousesCreate = 'Warehouses - Create',
  WarehousesUpdate = 'Warehouses - Update',
  WarehousesDelete = 'Warehouses - Delete',
  AreasList = 'Areas - List',
  AreasDetails = 'Areas - Details',
  AreasCreate = 'Areas - Create',
  AreasUpdate = 'Areas - Update',
  AreasExport = 'Areas - Export',
  AreasActivate = 'Areas - Activate',
  AreasSuspend = 'Areas - Suspend',
  LocationsList = 'Locations - List',
  LocationsDetails = 'Locations - Details',
  LocationsCreate = 'Locations - Create',
  LocationsUpdate = 'Locations - Update',
  LocationsUpload = 'Locations - Upload',
  LocationsDownload = 'Locations - Download',
  LocationsActivate = 'Locations - Activate',
  LocationsDeactivate = 'Locations - Deactivate',
  ZonesList = 'Zones - List',
  ZonesDetails = 'Zones - Details',
  ZonesCreate = 'Zones - Create',
  ZonesUpdate = 'Zones - Update',
  ZonesActivate = 'Zones - Activate',
  ZonesDeactivate = 'Zones - Deactivate',
  ZonesAddLocation = 'Zones - Add Location',
  ZonesDeleteLocation = 'Zones - Delete Location',
  DocksList = 'Docks - List',
  DocksDetails = 'Docks - Details',
  DocksCreate = 'Docks - Create',
  DocksUpdate = 'Docks - Update',
  DocksActivate = 'Docks - Activate',
  DocksDeactivate = 'Docks - Deactivate',
  //
  DispatchNotesDNCreate = 'Dispatch Notes (DN) - Create',
  ReservationsCancelReservation = 'Reservations - Cancel Reservation',
  InventoryHoldUnhold = 'Inventory Hold - Unhold',
  CycleCountDetails = 'Cycle Count - Details',
  TrainingList = 'Training - List',
  TrainingCreate = 'Training - Create',
  TrainingUpdate = 'Training - Update',
  TrainingDelete = 'Training - Delete',
  TrainingAddTrainee = 'Training - Add Trainee',
  TrainingDeleteTrainee = 'Training - Delete Trainee',
  GateSecurityList = 'Gate Security - List',
  GateDetails = 'Gate - Details',
  GateCreate = 'Gate - Create',
  GateUpdate = 'Gate - Update',
  GateActivateDeactivate = 'Gate - Activate/Deactivate',
  SKUList = 'SKU - List',
  SKUDetails = 'SKU - Details',
  SKUCreate = 'SKU - Create',
  SKUUpdate = 'SKU - Update',
  SKUDelete = 'SKU - Delete',
  SKUActivateSuspend = 'SKU - Activate/Suspend',
  SKUImport = 'SKU - Import',
  SKUExport = 'SKU - Export',
  SKUGroupList = 'SKU Group - List',
  SKUGroupDetails = 'SKU Group - Details',
  SKUGroupCreate = 'SKU Group - Create',
  SKUGroupUpdate = 'SKU Group - Update',
  SKUGroupDelete = 'SKU Group - Delete',
  SKUGroupActivateSuspend = 'SKU Group - Activate/Suspend',
  SKUClassList = 'SKU Class - List',
  SKUClassDetails = 'SKU Class - Details',
  SKUClassCreate = 'SKU Class - Create',
  SKUClassUpdate = 'SKU Class - Update',
  SKUClassDelete = 'SKU Class - Delete',
  SKUClassActivateSuspend = 'SKU Class - Activate/Suspend',
  SKUClassPutawayStrategyAddZone ='SKU Class - Putaway Strategy Add Zone',
  SKUClassPutawayStrategyDeleteZone ='SKU Class - Putaway Strategy Delete Zone',
  SKUClassPickFaceZoneAddZone ='SKU Class - Pick Face Zone Add Zone',
  SKUClassPickFaceZoneDeleteZone ='SKU Class - Pick Face Zone Delete Zone',
  SKUPackagingList = 'SKU Packaging - List',
  HazMatClassList = 'HazMatClass - List',
  HazMatClassDetails = 'HazMatClass - Details',
  HazMatClassCreate = 'HazMatClass - Create',
  HazMatClassUpdate = 'HazMatClass - Update',
  HazMatClassDelete = 'HazMatClass - Delete',
  LotMapList = 'LotMap - List',
  LotMapDetails = 'LotMap - Details',
  LotMapCreate = 'LotMap - Create',
  LotMapExport = 'LotMap - Export',
  LotMapUpdate = 'LotMap - Update',
  LotMapDelete = 'LotMap - Delete',
  BOQList = 'BOQ - List',
  KitManagementList ='Kit Management - List',
  KitManagementCreate ='Kit Management - Create',
  KitManagementBuild ='Kit Management - Build',
  KitManagementSuspend ='Kit Management - Suspend',
  KitManagementDelete ='Kit Management - Delete',
  KitManagementDetails ='Kit Management - Details',

  DispatchNotesDNProcess = 'Dispatch Notes (DN) - Process',
  TaskDetails = 'Task - Details',
  TaskOpen = 'Task - Open',
  TaskCancelJob = 'Task - Cancel Job',
  HoldList = 'Hold - List',
  HoldUnhold = 'Hold - Unhold',
  JobTitlesList = 'Job Titles - List',
  JobTitlesDetails = 'Job Titles - Details',
  JobTitlesCreate = 'Job Titles - Create',
  JobTitlesUpdate = 'Job Titles - Update',
  JobTitlesDelete = 'Job Titles - Delete',

  UserManagementList = 'User Management - List',
  DeviceManagementList = 'Device Management-List',
  DataManagementList = 'Data Management-List',
  OrchestrationList = 'Orchestration-List',
  ApprovalWorkflowList = 'Approval Workflow-List',
  LicenseCenterList = 'License Center-List',
  UniversalGatewayList = 'Universal Gateway-List',
  AuditTrailList = 'Audit Trail-List',

  UserRoleList = 'User Role - List',
  UserRoleDetails = 'User Role - Details',
  UserRoleCreate = 'User Role - Create',
  UserRoleUpdate = 'User Role - Update',
  UserRoleAssignprivilegedtorole = 'User Role - Assign privileged to role',

  ReportList = 'Report-List',

  UsersList = 'Users-List',
  UsersCreate = 'Users-Create',
  UserManagementDetails = 'User Management - Details',
  UserManagementCreate = 'User Management - Create',
  UserManagementUpdate = 'User Management - Update',
  UserManagementDelete = 'User Management - Delete',
  UserManagementResetPassword = 'User Management - Reset Password',
  UserManagementAddRoles = 'User Management - Add Roles',

  ChecklistList = 'Checklist - List',
  ChecklistDetails = 'Checklist - Details',
  ChecklistCreate = 'Checklist - Create',
  ChecklistUpdate = 'Checklist - Update',

  OrganizationsList = 'Organizations - List',
  OrganizationsDetails = 'Organizations - Details',
  OrganizationsCreate = 'Organizations - Create',
  OrganizationsUpdate = 'Organizations - Update',
  OrganizationsDelete = 'Organizations - Delete',
  OrganizationsActivateSuspend = 'Organizations - Activate/ Suspend',
  DivisionsList = 'Divisions - List',
  DivisionsDetails = 'Divisions - Details',
  DivisionsCreate = 'Divisions - Create',
  DivisionsUpdate = 'Divisions - Update',
  DivisionsDelete = 'Divisions - Delete',
  DivisionsActivateSuspend = 'Divisions - Activate/ Suspend',

  StockholderList = 'Stockholder - List',
  StockholderDetails = 'Stockholder - Details',
  StockholderCreate = 'Stockholder - Create',
  StockholderUpdate = 'Stockholder - Update',
  StockholderDelete = 'Stockholder - Delete',
  StockholderActivateSuspend = 'Stockholder - Activate/ Suspend',
  WarehouseProductivityActivityCount = 'Warehouse Productivity - Activity Count',
  SystemSettingsAdd = 'System Settings - Add',

  MyInboxList = 'My Inbox - List',
  AnnouncementsList = 'Announcements - List',
  MyReportsList = 'My Reports - List',
  MyPerformanceList = 'My Performance - List',
  BusinessCenterList = 'Business Center - List',
  ChemicalVolumeList = 'Chemical Volume -List',
  GatePassPrint = 'Gate Pass - Print',
  GatePassCreate = 'Gate Pass - Create',
  BusinessPartnersList = 'Business Partners - List',
  BusinessPartnersDetails = 'Business Partners - Details',
  BusinessPartnersCreate = 'Business Partners - Create',
  BusinessPartnersUpdate = 'Business Partners - Update',
  BusinessPartnersDelete = 'Business Partners - Delete',

  PacksList = 'Packs - List',
  PacksDetails = 'Packs - Details',
  PacksCreate = 'Packs - Create',
  PacksUpdate = 'Packs - Update',
  PacksDelete = 'Packs - Delete',
  SKUTypeList = 'SKU Type - List',
  SKUTypeDetails = 'SKU Type - Details',
  SKUTypeCreate = 'SKU Type - Create',
  SKUTypeUpdate = 'SKU Type - Update',
  SKUTypeDelete = 'SKU Type - Delete',
  SKUTypeActivateSuspend = 'SKU Type - Activate/ Suspend',
  HazardList = 'Hazard - List',
  HazardDetails = 'Hazard - Details',
  HazardCreate = 'Hazard - Create',
  HazardUpdate = 'Hazard - Update',
  HazardDelete = 'Hazard - Delete',

  WarehouseTransferCreate = 'Warehouse Transfer - Create',
  WarehouseTransferDelete = 'Warehouse Transfer - Delete',
  WarehouseTransferDetails = 'Warehouse Transfer - Details',
  WarehouseTransferList = 'Warehouse Transfer - List',
  WarehouseTransferAddLine = 'Warehouse Transfer - Add Line',

  WorkflowSettingsList='Workflow Settings - List',
  WorkflowSettingsCreate='Workflow Settings - Create',
  WorkflowSettingsDelete='Workflow Settings - Delete',

  IncidentMangagmentCreate = 'Incident - Create',
  
  IncidentTypeList ='Incident - List',
  IncidentTypeCreate ='IncidentType - Create',
  IncidentTypeUpdate ='IncidentType - Update',
  IncidentTypeDelete ='IncidentType - Delete',
  IncidentTypeDetails ='IncidentType - Details',

  TaskManagementList = 'Task - List',
  TaskManagementAssign = 'Task - Assign',
  
  DriverList = 'Driver - List',
  DriverUpdate = 'Driver - Update',
  DriverCreate = 'Driver - Create',
  DriverActivate = 'Driver - Activate',
  DriverDetails = 'Driver - Details',

  VehicleList  ='Vehicle - List' ,
  VehicleUpdate = 'Vehicle - Update',
  VehicleCreate = 'Vehicle - Create',
  VehicleActivate = 'Vehicle - Activate',
  VehicleDetails = 'Vehicle - Details'

}
